import { homApi } from '~/redux/apis/hom'

import { Session } from '~/types/tutoring-api'

import { SESSION_API_TAGS } from '~/redux/constants/tags.const'

import { PageRequest } from './types'

export const sessionApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getSession: builder.query<Session, number>({
      query: (id) => `/v1/sessions/${id}`,
      providesTags: (_, __, id) => [{ type: SESSION_API_TAGS.Sessions, id }],
    }),
    getSessions: builder.query<{ sessions: Session[] }, { date: string }>({
      query: (params) => `/v1/sessions/?date=${params.date}`,
    }),
    getSessionsList: builder.query<Session[], PageRequest & { from: string }>({
      query: (params) => ({
        url: '/v1/sessions/list',
        method: 'GET',
        params,
      }),
      providesTags: [SESSION_API_TAGS.Session],
    }),
    createSessions: builder.mutation<
      { sessions?: Session[]; error?: string },
      { sessions: Array<Omit<Session, 'status' | 'id' | 'type'>> } | { bookingId: number; mentorId: number }
    >({
      query: (data) => ({
        url: '/v1/sessions',
        method: 'POST',
        body: data,
      }),
    }),
    modifySession: builder.mutation<{ session: Session }, Partial<Session> & Pick<Session, 'id'>>({
      query: (body) => {
        const { id, ...session } = body
        return {
          url: `/v1/sessions/${id}`,
          method: 'PATCH',
          body: session,
        }
      },
      invalidatesTags: [SESSION_API_TAGS.Session],
    }),
  }),
})

export const {
  useGetSessionQuery,
  useCreateSessionsMutation,
  useGetSessionsQuery,
  useGetSessionsListQuery,
  useModifySessionMutation,
} = sessionApi
